export default {
  applicationStatusEnabled() {
    return process.env.APPLICATION_STATUS_ENABLED === 'true' ? true : false;
  }
};
